import { useState } from "react";
import { axios } from "@root/libs/axios";
import { csrfToken } from "@root/shared/utils/csrf";
import { sendErrorLog } from "@root/shared/utils/sendErrorLog";

const PICKUP_ON = 1;
const PICKUP_OFF = 2;

const STATUS_OK = 1;
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- レスポンス型の判別値として typeof 参照でのみ使用する
const STATUS_NG = 0;

type Response = {
  data: {
    on: typeof PICKUP_ON | typeof PICKUP_OFF;
  };
  exception: string | null;
  status: typeof STATUS_OK | typeof STATUS_NG;
};

type UsePickupReturnType = {
  isPickedUp: boolean;
  loading: boolean;
  postPickupData: (userId: string, value: boolean, pickupScoutUrl: string) => Promise<void>;
};

export const usePickup = (initialValue: boolean): UsePickupReturnType => {
  const [isPickedUp, setIsPickedUp] = useState(initialValue);
  const [loading, setLoading] = useState(false);

  const postPickupData = async (userId: string, value: boolean, pickupScoutUrl: string) => {
    try {
      setLoading(true);

      const { data } = await axios.post<Response>(pickupScoutUrl, {
        authenticityToken: csrfToken(),
        formClientFrontendPickup: {
          userId: userId || "",
          on: value ? PICKUP_OFF : PICKUP_ON,
        },
      });

      if (data.status !== STATUS_OK) {
        sendErrorLog(new Error(data.exception || "ピックアップの通信に失敗しました"));
        alert("ピックアップの処理に失敗しました。時間をおいて再度お試しください。");
        return;
      }
      if (data.data.on === PICKUP_ON) {
        setIsPickedUp(true);
        return;
      }
      setIsPickedUp(false);
    } catch (error) {
      // AxiosErrorをそのまま渡し、sendErrorLog内の通信断（ERR_NETWORK）除外を効かせる
      sendErrorLog(error as Error);
      alert("通信に失敗しました。時間をおいて再度お試しください。");
    } finally {
      setLoading(false);
    }
  };

  return { isPickedUp, loading, postPickupData };
};
